import { useContext } from "react";
import { Plus, ImperativeDialogContext } from "@repo/ui";
import BigButton from "~/components/ui/big-button";
import { PageContentLayout } from "~/components/ui/page-content-layout";
import { PageHeader } from "~/components/ui/page-header";
import { PageLayout } from "~/components/ui/page-layout";
import { useConfigurationSync } from "~/hooks/use-sync";
import { Lists } from "./lists";
import { ListDialog } from "./lists-dialog/list-dialog";

export const ListsPage = () => {
  useConfigurationSync("List");

  const dialogContext = useContext(ImperativeDialogContext);
  const { showDialog, closeDialog } = dialogContext ?? {};

  const showCreateListDialog = () => {
    showDialog?.({
      content: <ListDialog mode="create" onClose={closeDialog} onSuccess={closeDialog} />,
    });
  };

  return (
    <PageLayout>
      <PageHeader
        title="Lists"
        controls={
          <BigButton icon={<Plus />} iconPosition="right" onClick={showCreateListDialog}>
            <span className="max-lg:hidden">Create</span>
          </BigButton>
        }
      />
      <PageContentLayout>
        <Lists />
      </PageContentLayout>
    </PageLayout>
  );
};
